document.addEventListener('DOMContentLoaded', function () {
  Sceon.MemberProfile = {};
  Sceon.MemberProfile.commentContainer = '#member-profile-comments-container';

  Sceon.MemberProfile.getComments = function (page = 0) {
    const container = $(Sceon.MemberProfile.commentContainer);
    let overlay = new Sceon.Overlay(container, {
      loader: '/img/loader-tiny.gif',
      offset: { bottom: 0, top: 0 },
    });
    overlay.enable();

    let url = $(container).attr('rel');
    if (typeof page != 'undefined' && page) {
      url = url + '&page=' + page;
    }
    $.ajax({
      url: url,
      method: 'GET',
      success: function (resp) {
        $(container).html(resp);
        overlay.disable();
        let top = $(Sceon.MemberProfile.commentContainer).offset().top - 50;
        $('html, body').animate(
          {
            scrollTop: top,
          },
          500,
        );
      },
    });
  };
});
